// Generated from the QA Function policy. Keep allocation math identical.
(function(root,factory){var api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.StackhousePrintPricing=api;})(typeof window==='object'?window:this,function(){
const EMPTY = {operations: []};
var POLICY_VERSION = 'print-pricing-v1';
var PRO_RATES = {pro_artist:5,pro_artist_plus:8,pro_studio:10,pro_studio_plus:12,pro_elite:15,pro_elite_plus:20,partner:25};
const LOOSE = ['giclee-fine-art-prints','professional-photo-prints','rolled-canvas-prints','mini-prints'];
const EXCLUDED_PRODUCTS = ['gid://shopify/Product/15439799288115','gid://shopify/Product/15445589655859','gid://shopify/Product/15445589721395','gid://shopify/Product/15450425557299'];
const EXCLUDED_TAGS = ['standard-family:test-print','test-print-child','artist-supplies','rush-fee','rush-production','print-box-set'];
function flags(line) {
  const product=line.merchandise.product;
  const tags=(product.eligibilityTags||[]).filter(x=>x.hasTag).map(x=>x.tag);
  if(product.excluded || product.isGiftCard || EXCLUDED_PRODUCTS.includes(product.id) || tags.some(x=>EXCLUDED_TAGS.includes(x)) ||
      line.testPrint?.value==='Yes' || line.boxSet?.value || /scanning|scan service|rush production|gift card/i.test(product.productType||'') ||
      /^(scan|rush)-/i.test(line.merchandise.sku||'')) return {};
  const policy=product.eligibility?.jsonValue;
  if(policy != null) {
    if(policy.version!==1 || policy.policy!==POLICY_VERSION) return {};
    return {volume:policy.volume===true,pro:policy.pro===true,second:policy.second_copy===true};
  }
  return {volume:product.volumeEligible===true,pro:product.proEligible===true,
    second:product.volumeEligible===true && (LOOSE.includes(product.handle) || tags.some(x=>LOOSE.includes(x.replace(/^standard-family:/,''))) || tags.some(x=>['Giclee Fine Art Prints','Photo Prints','Canvas Prints','Mini Prints'].includes(x)))};
}
function evaluatePolicies(input) {
  const lines=(input.cart?.lines||[]).filter(line=>line.merchandise?.__typename==='ProductVariant' && Number.isInteger(line.quantity) && line.quantity>0);
  const eligible=lines.map(line=>({line,flags:flags(line),cents:Math.round(Number(line.cost?.amountPerQuantity?.amount)*100)}));
  const count=eligible.reduce((sum,x)=>sum+(x.flags.volume?x.line.quantity:0),0);
  const rate=count>=100?20:count>=50?15:count>=10?10:0;
  const customer=input.cart?.buyerIdentity?.customer;
  const proRate=customer?.proStatus?.value==='approved' ? PRO_RATES[customer?.proTier?.value]||0 : 0;
  function percentage(kind,percent,message) {
    const targets=eligible.filter(x=>x.flags[kind] && Number.isFinite(x.cents) && x.cents>0);
    if(!percent||!targets.length)return null;
    const gross=targets.reduce((sum,x)=>sum+x.cents*x.line.quantity,0);
    // Native Pro and 50+ volume offers round each copy. Preserve the
    // audited allocation rules rather than applying one rule to every offer.
    const savingsCents=(kind==='pro' || percent===15)
      ? targets.reduce((sum,x)=>sum+Math.floor(x.cents*percent/100)*x.line.quantity,0)
      : Math.floor(gross*percent/100);
    const value=(kind==='pro' || percent===15) ? {percentage:{value:percent}}
      : {fixedAmount:{amount:(savingsCents/100).toFixed(2),appliesToEachItem:false}};
    return {kind,rate:percent,savingsCents,candidate:{message,targets:targets.map(x=>({cartLine:{id:x.line.id}})),value}};
  }
  const volume=percentage('volume',rate,`Volume savings (${rate}%)`);
  const pro=percentage('pro',proRate,`Pro savings (${proRate}%)`);
  const pairs=rate?[]:eligible.filter(x=>x.flags.second && x.line.quantity>=2 && !x.line.sellingPlanAllocation && Number.isFinite(x.cents) && x.cents>0);
  pairs.sort((a,b)=>b.cents-a.cents||a.line.id.localeCompare(b.line.id));
  const pair=pairs[0];
  const second=pair?{kind:'second',savingsCents:Math.round(pair.cents*0.2),candidate:{message:'Second-copy savings (20%)',targets:[{cartLine:{id:pair.line.id}}],value:{fixedAmount:{amount:(Math.round(pair.cents*0.2)/100).toFixed(2),appliesToEachItem:false}}}}:null;
  const offers=[volume,pro,second].filter(x=>x&&x.savingsCents>0);
  return {volume,pro,second,best:offers.slice().sort((a,b)=>b.savingsCents-a.savingsCents)[0]||null};
}

// Fixed savings are distributed proportionally, with remaining pennies
// assigned in cart order. A newly added builder line is first.
function lineSavings(offer, lines, id) {
  if (!offer) return 0;
  const ids = new Set(offer.candidate.targets.map(x=>x.cartLine.id));
  const targets = lines.filter(x=>ids.has(x.id));
  const line = targets.find(x=>x.id===id);
  if (!line) return 0;
  if (offer.candidate.value.percentage) return Math.floor(Math.round(Number(line.cost.amountPerQuantity.amount)*100)*offer.rate/100)*line.quantity;
  const total = Math.round(Number(offer.candidate.value.fixedAmount.amount)*100);
  const weights = targets.map(x=>Math.round(Number(x.cost.amountPerQuantity.amount)*100)*x.quantity);
  const gross = weights.reduce((a,b)=>a+b,0);
  if (!gross) return 0;
  const amounts = weights.map(x=>Math.floor(total*x/gross));
  let remaining = total-amounts.reduce((a,b)=>a+b,0);
  for (let i=0;remaining>0;i=(i+1)%amounts.length,remaining--) amounts[i]++;
  return amounts[targets.indexOf(line)];
}
return {evaluatePolicies:evaluatePolicies,lineSavings:lineSavings,policyVersion:POLICY_VERSION};
});
